export default __webpack_public_path__ + "static/media/sql.c5b17f63.png";